const actions = {
    REQUEST_TO_CANCEL: 'REQUEST_TO_CANCEL',
    REQUEST_TO_MODIFY_NEW: 'REQUEST_TO_MODIFY_NEW',
    REQUEST_TO_WITHDRAW: 'REQUEST_TO_WITHDRAW',
    SELF_SERVICE_CANCEL: 'SELF_SERVICE_CANCEL',
};

export default actions;
